<template>
<div id="activo_fijo_grupo">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Activo Fijo" class="elevation-1 px-5 py-3">
          <br>

          <div class="contenedor-tab-reportes">
            <v-card-text>
              <v-card-title>
                <span class="headline"></span>
              </v-card-title>
              <v-form ref="form" lazy-validation>
                <v-container grid-list-md text-xs-center>
                  <v-row row wrap>
                      <v-col sm="12" md="6">
                          <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="RFC" @change="cargarReportes()" :rules="[rules.required]">
                          </v-autocomplete>
                      </v-col>
                  </v-row>

                  <v-row row wrap>
                    <v-col sm="12" md="6" lg="6">
                      <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                            :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                        </template>

                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="6" lg="6">
                      <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                            :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                        </template>
                        <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                    </v-col>
                  </v-row>
                </v-container>

              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="success" @click="generar_reporte_sqs">
                <v-icon>done</v-icon>Generar Reporte
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <v-refresh-button :funcion="cargarReportes" />
              <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)">
                    <v-icon dark>get_app</v-icon>
                  </v-btn>
                  <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </template>
              </v-client-table>
            </v-card-text>
          </div>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.tipo = 1;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.get_clientes_grupo();

  },
  computed: {},
  data: () => ({
    permisoEliminar: false,
    fab: false,
    rfcs: [],
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/admin"
      },
      {
        text: "Activo Fijo",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      reportesPartidas: [],
      reportesDescargos: [],
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "",
      nombre_reporte: "",
      tipo: "ActivoFijoWS",
      opc_impo: 1,
      opc_expo: 1,
      opc_descripcion: 1,
    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,

  }),
  methods: {
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        this.model.tipo = "ActivoFijoWS";
        this.model.reporte_url = "/reportes_ws/partidas_activo_fijo/";
        this.model.nombre_reporte = "Pref. Arancelarias Activo Fijo";

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: this.model
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      if (this.model.rfc == "" || this.model.rfc == null) {
        return false;
      }
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "ActivoFijoWS"
      };
      axios.post(this.$hostname + "reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
              this.cargarReportesPartida();
              this.cargarReportesDescargos();
            });
        }
      });
    },
    get_clientes_grupo: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
          usuario: this.$local_storage.get("id_usuario"),
          sistema: this.$sistema,
      };

      axios.post(this.$hostname + "usuarios/get_clientes_grupo/", data)
        .then(res => {
          if (res.data != undefined) {
            this.rfcs= res.data;
          } else {
            this.rfcs = [];
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los RFC del Grupo.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.elevation-1 .v-expansion-panel>>>.v-label.theme--light {
  color: black !important;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control {
  margin-bottom: -35px;
}

.elevation-1>>>.v-input--has-state>div:nth-child(1)>div:nth-child(2) {
  margin-top: -10px;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light {
  font-size: 10px !important;
}

.v-card__text>>>.columnadescripcion {
  white-space: normal !important;
  max-width: 300px !important;
}

.v-card__text>>>.columnaidentificadores {
  white-space: normal !important;
  max-width: 450px !important;
}
</style>
